/* __next_internal_client_entry_do_not_use__ Send auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=161%3A331))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.057Z
 */ export var Send = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M9.97345 18.8435L13.714 22.5789C13.9462 22.8111 14.2339 22.9802 14.5498 23.0699C14.8657 23.1597 15.1993 23.1672 15.5189 23.0918C15.8385 23.0164 16.1336 22.8606 16.3761 22.6391C16.6185 22.4176 16.8004 22.1379 16.9043 21.8264L23.0432 3.39265C23.1565 3.05333 23.1731 2.68914 23.091 2.34092C23.009 1.99271 22.8315 1.67425 22.5785 1.42128C22.3256 1.16831 22.0071 0.990836 21.6589 0.908764C21.3107 0.826693 20.9465 0.843274 20.6072 0.956648L2.17345 7.10065C1.86293 7.20499 1.58413 7.38679 1.3634 7.62885C1.14268 7.87092 0.987311 8.16526 0.911984 8.48407C0.836657 8.80288 0.843855 9.13564 0.932899 9.45089C1.02194 9.76615 1.18989 10.0535 1.42088 10.2858L6.11974 14.9898L5.96031 20.9298L9.97345 18.8435Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M22.4933 1.33984L6.12012 14.989",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "Send", function(strictLocalize) {
    return {
        viewBox: "0 0 24 24",
        titleAccess: strictLocalize({
            id: "cTUgCl",
            defaultMessage: [
                {
                    type: 0,
                    value: "Send"
                }
            ]
        }),
        fill: "none",
        color: Core.icon.default
    };
});
